import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useAppMessage, useDaily, useLocalParticipant } from '@daily-co/daily-react';

import { RecordStartButton, RecordStopButton } from './Icons';
import { recordLocalAtom, mouthShapeAtom, isTextToSpeechAtom } from '../../State';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Tray.css';
import isElectron from '../../Global';
import DataModel from '../Util/DataModel';
import { ReactComponent as CloseWhiteSVG } from '../Images/buttons/windowCloseButtonWhite.svg';
import { ReactComponent as ArrowSVG } from '../Images/buttons/downArrow.svg';
import { ReactComponent as EditWhiteSVG } from '../Images/buttons/editButtonWhite.svg';
import axios from 'axios';
import { duration } from '@mui/material';

export default function TraySpeech({ isLive }) {
  const { t } = useTranslation();
  const localParticipant = useLocalParticipant();
  const urlParam = useParams();
  var roomID = urlParam.id; //URL取得
  let showThisNFT = roomID == 'makopt' || roomID == '144987874' ? true : false;

  const [isTextToSpeechState, setIsTextToSpeechState] = useRecoilState(isTextToSpeechAtom);
  const [showSpeech, setShowSpeech] = useState(false);
  const setMouthShapeState = useSetRecoilState(mouthShapeAtom);
  const [showVoiceSelect, setShowVoiceSelect] = useState(false);
  const [voiceState, setVoiceState] = useState('en1');
  const aboutMeRef = useRef(null);
  const [aboutMeState, setAboutMeState] = useState(null);
  const timerRef = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    // const handleEsc = (e) => {
    //   if (e.code == 'Enter' && e.shiftKey) {
    //     if (showSpeech == true) {
    //       setShowSpeech(false);
    //     } else {
    //       setShowSpeech(true);
    //     }
    //     //setShowSpeech(showSpeech == true ? false : true);
    //   }
    // };
    // window.addEventListener('keydown', handleEsc);
    // return () => {
    //   // window.removeEventListener('keydown', handleEsc);
    // };

    setShowSpeech(isTextToSpeechState);
  }, [isTextToSpeechState]);

  const selectVoice = async (status) => {
    setVoiceState(status);
    setShowVoiceSelect(false);
  };

  const sendText = async () => {
    //リセット
    setAboutMeState('');

    try {
      let baseURL = 'https://api.faceless.ooo';

      axios
        .post(baseURL, {
          text: aboutMeState,
          type: voiceState,
        })
        .then((res) => {
          const data = res.data;
          let duration = data.duration / 10000;

          console.log(duration);

          let url = baseURL + '/?name=' + data.url;

          console.log(url);

          //他のユーザーに送信
          sendAppMessage(
            {
              type: 'speech',
              url: url,
              id: localParticipant?.session_id,
              duration: duration,
            },
            '*',
          );

          //再生
          moveMouth(duration);
          let audio = new Audio(url);
          audio.play();
        });
    } catch (err) {
      console.log('エラー');
    }
  };

  async function moveMouth(time = 2000) {
    //既存のがあればクリア
    if (intervalRef.current != null) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    if (timerRef.current != null) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }

    //指定時間分後に繰り返し処理をストップ
    timerRef.current = setTimeout(() => {
      clearInterval(intervalRef.current);
      setMouthShapeState(0);
      timerRef.current = null;
      intervalRef.current = null;
    }, time);

    //100msごとにランダム数送信
    intervalRef.current = setInterval(() => {
      let randomNum = Math.random();
      setMouthShapeState(randomNum);
    }, 100);
  }

  //メッセージ受信をリッスン
  const sendAppMessage = useAppMessage({
    onAppMessage: useCallback((ev) => {
      if (ev.data.type == 'speech') {
        let url = ev.data.url;

        //再生
        let audio = new Audio(url);
        audio.play();
      }
    }, []),
  });

  //Enterキーを押された時
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      //
      e.preventDefault();
      sendText();
    }
  };

  //Aboutmeの変更時
  const onChangeAboutMe = (e) => {
    setAboutMeState(e.target.value);
  };

  //フォーカスがハズレた場合
  const aboutMeBlur = () => {
    //名前編集中の時
  };

  const closeSpeech = () => {
    setIsTextToSpeechState(false);
    console.log('hi');
  };

  if (showThisNFT == false || showSpeech == false) {
    return false;
  }

  //レンダー
  return (
    <>
      <div className="speechWrap">
        {showVoiceSelect && (
          <>
            <div className="speechListBack" onClick={() => setShowVoiceSelect(false)}></div>
            <div className="speechList">
              <div className="speechListTitle">{t('speech.Select Voice')}</div>
              <ul>
                <li
                  className={voiceState == 'en1' ? 'selected' : ''}
                  onClick={() => selectVoice('en1')}>
                  {t('speech.Bob (English)')}
                </li>
                <li
                  className={voiceState == 'en2' ? 'selected' : ''}
                  onClick={() => selectVoice('en2')}>
                  {t('speech.Sara (English)')}
                </li>
                <li
                  className={voiceState == 'ja1' ? 'selected' : ''}
                  onClick={() => selectVoice('ja1')}>
                  {t('speech.Hiro (Japanese)')}
                </li>
                <li
                  className={voiceState == 'ja2' ? 'selected' : ''}
                  onClick={() => selectVoice('ja2')}>
                  {t('speech.Miki (Japanese)')}
                </li>
              </ul>
            </div>
          </>
        )}
        <div className="speechWrapTitle">Speech</div>
        <div className="speechWrapEdit" onClick={() => setShowVoiceSelect(true)}>
          {voiceState == 'en1' && t('speech.Bob (English)')}
          {voiceState == 'en2' && t('speech.Sara (English)')}
          {voiceState == 'ja1' && t('speech.Hiro (Japanese)')}
          {voiceState == 'ja2' && t('speech.Miki (Japanese)')}
          <ArrowSVG />
        </div>
        <div className="speechWrapClose" onClick={closeSpeech}>
          <CloseWhiteSVG />
        </div>
        <div className="speechWrapInside">
          <textarea
            ref={aboutMeRef}
            placeholder={t('speech.Type text here')}
            value={aboutMeState ?? ''}
            onChange={(e) => onChangeAboutMe(e)}
            onKeyPress={handleKeyDown}
            autoFocus={true}
            onBlur={aboutMeBlur}></textarea>
        </div>
        {/* <button onClick={sendText}>Send</button> */}
      </div>
    </>
  );
}
